// extracted by mini-css-extract-plugin
module.exports = {"container":"Report_container__2GUk1","report":"Report_report__2lYY4"};